import React, { useState } from 'react';
import './feedback.css'; // Import the CSS file

const Feedback = ({ isLightMode }) => {
    // State for form values
    const [feedbackType, setFeedbackType] = useState('Experiences');
    const [feedbackTopic, setFeedbackTopic] = useState('Experience cost');
    const [details, setDetails] = useState('');

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle the submission logic here
        console.log('Feedback submitted:', { feedbackType, feedbackTopic, details });
    };

    return (
        <div className="feedback-container">
            <h2 className="feedback-heading">Share your feedback</h2>
            <p className="feedback-description">
                Thanks for sending us your ideas, issues, or appreciations. We can’t respond individually, but we’ll pass it on to the teams who are working to help make our platform better for everyone.
            </p>
            <p className="feedback-help">
                If you do have a specific question, or need help resolving a problem, you can <a href="/contact-us">contact us</a> to connect with our support team.
            </p>

            <form onSubmit={handleSubmit} className="feedback-form">
                <div className="form-group">
                    <label htmlFor="feedbackType">What's your feedback about?</label>
                    <select
                        id="feedbackType"
                        value={feedbackType}
                        onChange={(e) => setFeedbackType(e.target.value)}
                        className="feedback-select"
                    >
                        <option value="Experiences">Experiences</option>
                        <option value="Stays">Games</option>
                        <option value="Hosts">Quizzes</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="feedbackTopic">What topic or feature?</label>
                    <select
                        id="feedbackTopic"
                        value={feedbackTopic}
                        onChange={(e) => setFeedbackTopic(e.target.value)}
                        className="feedback-select"
                    >
                        <option value="Experience cost">Gameplay</option>
                        <option value="Booking issues">Topics issues</option>
                        <option value="Customer support">Customer support</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="details">Add details</label>
                    <textarea
                        id="details"
                        value={details}
                        onChange={(e) => setDetails(e.target.value)}
                        className="feedback-textarea"
                        rows="4"
                        placeholder="Provide additional details here"
                    ></textarea>
                </div>

                <button type="submit" className="feedback-submit">Submit</button>
            </form>
        </div>
    );
};

export default Feedback;
